


import React from 'react';
import PropTypes from 'prop-types';
// import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Typography, } from '@material-ui/core';
import { SectionHeader } from 'components/molecules';
import { CardBase } from 'components/organisms';
import { Image } from 'components/atoms';

import Cryoprep from 'components/Popups/Covaris/Cryoprep'
// import Eseries from 'components/Popups/Covaris/Eseries'
import Meseries from 'components/Popups/Covaris/Meseries'
import Mseries from 'components/Popups/Covaris/Mseries'
import Ultrasonic from 'components/Popups/Covaris/Ultrasonic'






const useStyles = makeStyles(theme => ({
  cardBase: {
    '&:hover': {
      background: "#7DEDFF",
      '& .card-icon, & .card-title': {
        color: 'white',
      },
    },
  },
  icon: {
    fontSize: 60,
    color: theme.palette.primary.main,
    [theme.breakpoints.up('sm')]: {
      fontSize: 80,
    },
  },
  title: {
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(6),
    },
  },
}));

const Covarisall = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
             <CardBase >

<Image src="https://onwhicar.sirv.com/premas/main/covaris/covaris.png" />

</CardBase>

<br/>


      <SectionHeader
        title="Featured products"
        subtitle="COVARIS"
        data-aos="fade-up"
      />

      <Grid container spacing={isMd ? 4 : 2}>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://onwhicar.sirv.com/premas/main/covaris/le220rsc.png" />


            </div>
            <Typography align = 'center' variant="h6" component="span" className={classes.fontWeight900}>
              <h3>L Series </h3>&nbsp;
        <Typography  variant="inherit" color="primary">Focused Ultrasonicators</Typography>
            </Typography>


            <br />
            <br />

            <Ultrasonic />


          </CardBase>
        </Grid>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://onwhicar.sirv.com/premas/main/covaris/CP02.png" />
            </div>
            
            <br />
            <br />
            <br />
            <br />
            <br />
            
            <Typography align = 'center' variant="h6" component="span" className={classes.fontWeight900}>
              <h3>Cryoprep </h3>&nbsp;
              {/* <Typography  variant="inherit" color="primary">system</Typography> */}
            </Typography>


            <br />
            <br />

            <Cryoprep />



          </CardBase>
        </Grid>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://onwhicar.sirv.com/premas/main/covaris/m220.png" />
            </div>
            <Typography align = 'center' variant="h6" component="span" className={classes.fontWeight900}>
              <h3> M220 </h3>&nbsp;
              <Typography align='center' variant="inherit" color="primary">Focused Ultrasonicators</Typography>
            </Typography>

            <br />
            <br />
            <Mseries />





          </CardBase>
        </Grid>
      </Grid>
      <Grid container spacing={isMd ? 4 : 2}>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://onwhicar.sirv.com/premas/main/covaris/500506_1.png" />


            </div>
            <Typography align = 'center' variant="h6" component="span" className={classes.fontWeight900}>
              <h3>Meseries </h3>&nbsp;
              <Typography variant="inherit" color="primary">2000</Typography>
            </Typography>


            <br />
            <br />

            <Meseries />


          </CardBase>
        </Grid>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          {/* <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/Covaris/E220covaris_rm0l8ijdN_M.png?updatedAt=1628163984671" />
            </div>
            <br/>
            <br/>
            <br/>
            <br/>
            <Typography align = 'center' variant="h6" component="span" className={classes.fontWeight900}>
              <h3>Eseries </h3>&nbsp;
              <Typography variant="inherit" color="primary"> Ultrasonicators</Typography>
            </Typography>

            <br />
            <br />

            <Eseries />



          </CardBase> */}
        </Grid>
        <Grid item xs={12} sm={4} data-aos="fade-up">

        </Grid>
      </Grid>
      <Grid container spacing={isMd ? 4 : 2}>
        <Grid item xs={12} sm={4} data-aos="fade-up">

        </Grid>


      </Grid>
    </div>
  );
};

Covarisall.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Covarisall;
